import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TravelBookingsList.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { BookingIcons, BookingTypes, SpecificationsCollector, SpecificationsIndividual, TravelBookingListData } from "./TravelBookingListTypes";
import TravelBookingForm from './TravelBookingForm/TravelBookingForm';
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import TravelBookingView from './TravelBookingForm/TravelBookinView';

class TravelBookingsList extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    private project: VAM2types.EvProjectEntity_Extended;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<TravelBookingListData>>>;

    //private bookingTypeSelect: SelectBox;
    //private bookingSpecificationSelect: SelectBox;
    //private addTravelBookingButton: HTMLButtonElement;

    private tableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["classname", "desccription", "dateStart", "dateEnd"],
        "attributes": ["ClassPrintname", "description", "date_start", "date_end"],
        "headings": [(this as any).translate("TravelBookingList_Headings_Type"), (this as any).translate("TravelBookingList_Headings_Description"), "Start", "Ende"],
        bgColors: [null, null, null, null],
    }
    

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    loadData() {
        this.StandbyStart();


        this.RequestManager.callfunction(
            "Webtool_API_Travel__GetListData",
            {
                "projectId": this.project.ID 
            },
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError)
        )
    }

    private _onLoadDataError(error: more.requestErrorMessage) {
        this.StandbyStop();
        console.error(error);
    }

    private _onLoadDataResponse(response: Array<TravelBookingListData>) {
        this.StandbyStop();
        this.setup(response, this.project);
    }

    private setupTable(): void {
        this.tableContainer.innerHTML = null;


        this.table = new StaticTable();
        this.table.setRowClick(lang.hitch(this, this._onTableRowClick))


        this.table.addLineConfig(this.tableLayout);
        this.table.setCyAttribute("TravelBookingsList");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        this.table.setupFromStore(this.store);
    } 

    private _createTravelBookingForm(type: string): MdsLax<InstanceType<typeof TravelBookingForm>> {
        var newForm: MdsLax<InstanceType<typeof TravelBookingForm>> = new TravelBookingForm(type);
        //newForm.on("save", lang.hitch(this, this.loadData));
        //newForm.on("deleted", lang.hitch(this, this.loadData));
        //newForm.on("newBookingForm", lang.hitch(this, this._processNewBookingFormEmit));
        return newForm;
    }

    private _processNewBookingFormEmit(entity)
    {
        //this._openTravelBookingForm(entity);
    }


    private _openTravelBookingForm(entity?: TravelBookingListData, bookingType?: string) {
        var travelBookingForm: MdsLax<InstanceType<typeof TravelBookingForm>> = this._createTravelBookingForm(entity ? entity.Classname : bookingType);
        travelBookingForm.on("deleted", lang.hitch(this, this.loadData));
        travelBookingForm.on("save", lang.hitch(this, this.loadData));
        travelBookingForm.on("newBookingForm", lang.hitch(this, this._openTravelBookingForm));


        var project: VAM2types.EvProjectEntity_Extended = this.project;

        var isNew: boolean;
        var bookingType: string;
        var label: string;
        var id: string = null;

        if (entity) {
            isNew = false;
            bookingType = entity.Classname;
            label = travelBookingForm.getTabTitle();
            id = entity.ID;
        } else {
            isNew = true;
            bookingType = bookingType;
        }

        travelBookingForm.setupForm(isNew, bookingType, project, id);

        if (!label) label = travelBookingForm.getTabTitle();

        if (this.getTabContainer()) {

            let tabConfig: Tabbing.TabPageDescriptor = {
                targetContainerName: this.getContainerName(),
                enableClosing: true,
                label: label,
                name: id ? id : "_blank",
                widget: travelBookingForm,
                groupLabel: label,
            };
            this.requestNewTabbedContent(tabConfig, true);
            this.requestTabswitch(tabConfig.name);
        } else {
            var dlg = new GenericDialog();
            dlg.keepOpen = true;
            dlg.show(travelBookingForm, label, null);
            dlg._setOkBtnAttr(false);
            dlg.addButton("save", this.translate("General_Save"), lang.hitch(travelBookingForm, travelBookingForm._onSaveButtonClick), null, "accentBG", "fas fa-save", false, "first");
            dlg.addButton("close", this.translate("General_Close"), lang.hitch(travelBookingForm, this._onDlgClose, travelBookingForm, dlg));
            dlg.disableButton("save");
            travelBookingForm.on("dirty", lang.hitch(dlg, dlg.enableButton, "save"));
            travelBookingForm.on("close", lang.hitch(dlg, dlg.close));
        }
        travelBookingForm.startup();
    }


    private _onTableRowClick(row: StaticTable.StaticTableRow<TravelBookingListData>): void {
        var entity = row.rowGroup.entity;
        this._openViewer(entity);
        //this._openTravelBookingForm(entity, entity.Classname);

        //this._openTravelBookingForm(entity);
    }



    private _onAddButtonClick(): void {
        this._openTravelBookingForm();
    }
    

    private _openViewer(data: TravelBookingListData, evt?: MouseEvent) {

        if (evt) {
            evt.stopPropagation();
        }

        var travelBookingId = data.ID;
        var form: MdsLax<InstanceType<typeof TravelBookingView>> = null;

        var tabContainerName = this.getTabContainerName();
        var tab = window.tabManager.getExistingTab(travelBookingId);


        form = new TravelBookingView();
        form.on("deleted", lang.hitch(this, this.loadData));
        form.on("save", lang.hitch(this, this.loadData));
        form.on("newBookingForm", lang.hitch(this, this._openTravelBookingForm));
        form.setup(travelBookingId, data.description, data, this.project, lang.hitch(this, this._openTravelBookingForm, data), null, "projectWizard", tabContainerName);


    }

    private openedBookings: Array<{ entityID: string, form: any }>;
    private openEditor(data: TravelBookingListData, evt?: MouseEvent) {

        if (evt) {
            evt.stopPropagation();
        }





    }

    private getOpenBookingById(entityId: string): any {
        let openIndex: number = -1;
        for (let index = 0; index < this.openedBookings.length; index++) {
            let openBooking = this.openedBookings[index];

            if (openBooking.entityID == entityId) {
                if (window.tabManager) {
                    if (window.tabManager.getExistingTab(entityId) == null) {

                    } else {
                        openIndex = index;
                        return this.openedBookings[openIndex];
                    }
                } else {
                    openIndex = index;
                    return this.openedBookings[openIndex];
                }
                break;
            }
        }

        return null;
    }

    private _onClickDropdownButton(e): void {
        var floatingMenu: MdsLax<InstanceType<typeof FloatingMenu>> = new FloatingMenu();
        var bookingTypes = Object.keys(BookingTypes);
        bookingTypes.forEach((bookingType) => {
                var icon = this.UiModder.domConstruct.create("i");
                this.UiModder.domClass.add(icon, BookingIcons[bookingType]);

   

            floatingMenu.addEntry({
                callback: lang.hitch(this, this._onClickMenuEntry, bookingType),
                label: this.translate(BookingTypes[bookingType]),
                heading: SpecificationsIndividual[bookingType] ? this.translate("TravelBookingList_Select_IndividualBooking") : this.translate("TravelBookingList_Select_BookingCollection"),
                groupname: SpecificationsIndividual[bookingType] ? this.translate("TravelBookingList_Select_IndividualBooking") : this.translate("TravelBookingList_Select_BookingCollection"),
                icon: icon
                
            });
        });
        floatingMenu.open(e, null, this.translate("TravelBookingsList_Label_AddTravelBooking"));
    }

    private _onClickMenuEntry(bookingType: string, e): void {
        this._openTravelBookingForm(null, bookingType);
    }

    private _onDlgClose(form: MdsLax<InstanceType<typeof TravelBookingForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>) {
        var isClosed = form._onCloseRequest();
        if (isClosed) {
            dlg.close();
        }
    }

    //private _onTypeChange(e: string): void {
    //    if (e === "") {
    //        this.bookingSpecificationSelect.entries = [];
    //        this.bookingSpecificationSelect.blankOption = null;
    //        this.bookingSpecificationSelect.constructOptions();
    //        this.disableNode(this.bookingSpecificationSelect, true);
    //    } else {
    //        this._setupBookingSpecificationSelectBox(e);
    //    }
    //    this.disableNode(this.addTravelBookingButton, true);

    //}

    //private _onSpecificationChange(e): void {
    //    if (e !== "") {
    //        this.disableNode(this.addTravelBookingButton, false);
    //    } else {
    //        this.disableNode(this.addTravelBookingButton, true);
    //    }
    //}

    //private _setupBookingTypeSelectBox(): void {
    //    var bookingTypes = Object.keys(BookingType);

    //    bookingTypes.forEach((type) => {
    //        if (isNaN(Number(type))) {
    //            this.bookingTypeSelect.addOption(
    //                type,
    //                this.translate(BookingType[type]),
    //                true
    //            )
    //        }
    //    });
    //    this.bookingTypeSelect.setBlankOption("", this.translate("TravelBookingList_Select_ChooseBookingType"));
    //}

    //private _setupBookingSpecificationSelectBox(type: string): void {
    //    switch (type) {
    //        case "booking_individual":
    //            this.bookingSpecificationSelect.setBlankOption("", this.translate("TravelBookingList_Select_ChooseBooking"));
    //            this.bookingSpecificationSelect.entries = [];
    //            var individual_booking_types = Object.keys(SpecificationsIndividual);
    //            individual_booking_types.forEach((type) => {
    //                if (isNaN(Number(type))) {
    //                    console.log(type);
    //                    this.bookingSpecificationSelect.addOption(
    //                        type,
    //                        this.translate(SpecificationsIndividual[type]),
    //                        true
    //                    );
    //                }
    //            });
    //            this.bookingSpecificationSelect.constructOptions();
    //            this.disableNode(this.bookingSpecificationSelect, false);
    //            break;
    //        case "booking_collector":
    //            this.bookingSpecificationSelect.setBlankOption("", this.translate("TravelBookingList_Select_ChooseBookingCollection"));
    //            this.bookingSpecificationSelect.entries = [];
    //            var collector_booking_types = Object.keys(SpecificationsCollector);
    //            collector_booking_types.forEach((type) => {
    //                if (isNaN(Number(type))) {
    //                    console.log(type);
    //                    this.bookingSpecificationSelect.addOption(
    //                        type,
    //                        this.translate(SpecificationsCollector[type]),
    //                        true
    //                    );
    //                }
    //            });
    //            this.bookingSpecificationSelect.constructOptions();
    //            this.disableNode(this.bookingSpecificationSelect, false);
    //            break;
    //        default:
    //            console.log("default");
    //            this.bookingSpecificationSelect.entries = [];
    //            this.bookingSpecificationSelect.constructOptions();
    //            this.disableNode(this.bookingSpecificationSelect, true);
    //            break;
    //    }
    //}

    private _sortTableData(data: Array<TravelBookingListData>) {
        data.sort((a, b) => {
            var dateA = new Date(a.date_start);
            var dateB = new Date(b.date_start);

            if (a.date_start === "") {
            }

            if (a.date_start === "") {
                return 1;
            } else if (b.date_start === "") {
                return -1;
            } else if (dateA >= dateB) {
                return 1;
            } else {
                return -1;
            }
        });
    }

    setup(data: Array<TravelBookingListData>, project: VAM2types.EvProjectEntity_Extended) {
        this._sortTableData(data);

        this.store.setup(data, "ID");
        this.project = project;
        this.setupTable();
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();

        //this._setupBookingTypeSelectBox();
        //this.disableNode(this.bookingSpecificationSelect);
        //this.disableNode(this.addTravelBookingButton);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TravelBookingsList);